import * as RxCheckbox from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../lib/cn';

export interface CheckboxProps {
  checked: boolean | 'indeterminate';
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
}

/** Чекбокс по макетам: оранжевый при выборе, поддержка indeterminate («Выбрать все»). */
export function Checkbox({ checked, onCheckedChange, id, className, disabled, ...rest }: CheckboxProps) {
  return (
    <RxCheckbox.Root
      id={id}
      checked={checked}
      disabled={disabled}
      onCheckedChange={(v) => {
        onCheckedChange(v === true);
      }}
      className={cn(
        'grid h-5 w-5 shrink-0 place-items-center rounded-[6px] border border-border-strong bg-surface',
        'data-[state=checked]:border-brand data-[state=checked]:bg-brand',
        'data-[state=indeterminate]:border-brand data-[state=indeterminate]:bg-brand',
        'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40',
        className,
      )}
      {...rest}
    >
      <RxCheckbox.Indicator className="text-white">
        {checked === 'indeterminate' ? (
          <Minus className="h-3.5 w-3.5" strokeWidth={3} />
        ) : (
          <Check className="h-3.5 w-3.5" strokeWidth={3} />
        )}
      </RxCheckbox.Indicator>
    </RxCheckbox.Root>
  );
}
